import React from 'react';

import { ReactComponent as DeleteTemplateIcon } from '@assets/svg/il-deleteTemplate.svg';

import ModalHeader from '@components/modals/ModalHeader/ModalHeader';
import Button from '@components/uikit/Button/Button';

import { MODAL_NAMES } from '@constants/modalRenderers';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import type { ITemplate } from '@model/templateItem';

import { useDeleteTemplateMutation } from '@pages/MultiplicationFactors/services/useDeleteTemplateMutation';

import { useModalActions } from '@store/useModalStore';

import style from './style.module.scss';

interface IProps {
  currentTemplate: ITemplate;
}

const TemplateDeleteModal: React.FC<IProps> = ({ currentTemplate }) => {
  const { t } = useTranslation();
  const { setModalClose, setSecondaryModal } = useModalActions();

  const { mutate: deleteTemplateMutate } = useDeleteTemplateMutation();

  const getDeleteTemplate = (recalculate: number) => {
    deleteTemplateMutate(
      { id: currentTemplate.id, recalculate_cost_saving: recalculate },
      {
        onSuccess: () => {
          showToast({ variant: 'success', message: t('Template successfully deleted.') });

          setModalClose();
        },
      },
    );
  };

  const onConfirm = () => {
    setSecondaryModal({
      name: MODAL_NAMES.modalConfirm,
      options: {
        bodyTitle: t('Recalculate archived action items?'),
        bodyContent: t(
          'After saving a new multiplication factor value, do existing completion reports (open and archive) need to be recalculated?',
        ),
        onConfirm: () => {
          getDeleteTemplate(1);
        },
        onCancel: () => {
          getDeleteTemplate(0);
        },
        confirmText: t('Recalculate'),
        cancelText: t(`Don't Recalculate`, {}, true),
      },
    });
  };

  return (
    <div className={style.templateDeleteModal}>
      <ModalHeader onClose={setModalClose} />
      <div className={style.modalBody}>
        <div className={style.modalBodyTitle}>
          {t('Delete Template')} <br /> "{currentTemplate.name}"
        </div>
        <DeleteTemplateIcon />
        <div className={style.confirmText}>{t('Are you sure you want to delete this template?')}</div>
      </div>
      <div className={style.modalFooter}>
        <Button type="primary" text={t('Delete')} onClick={onConfirm} />
        <Button type="secondary" text={t('Cancel')} onClick={setModalClose} />
      </div>
    </div>
  );
};

export default TemplateDeleteModal;
